import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const getCard = async (cardId: string): Promise<cardApiSpec.Card> => {
  const { data } = await cardsService.get(`/${cardId}`);

  return data;
};
